import { OuraRing4Logo } from '@jouzen/ecom-components/icons/OuraRing4Logo';
import { InverseHeader } from '@jouzen/ecom-components/layout';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import { EventType } from '@/analytics/types';
import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';

import HomeHero from '../HomeHero';
import StatsigHomeHeroShopChiclet from '../HomeHeroShopChiclet';
import HomeHeroWithChicletWrapper from '../HomeHeroWithChicletWrapper';
import HsaFsaIcon from './common/HsaFsaIcon';
import OR4HeroBackground from './common/OR4HeroBackground';

const gen4RichText = {
  em: function em(chunks: ReactNode) {
    return (
      <Motion
        className="mt-2 font-serif leading-tight italic md:mt-4"
        el="em"
        initial={{
          opacity: 0,
          translateY: 25,
          filter: 'blur(5px)',
          background: 'inherit',
        }}
        animate={{ opacity: 1, translateY: 0, filter: 'none' }}
        transition={{ duration: 2, type: 'tween', delay: 1.25 }}
      >
        {chunks}
      </Motion>
    );
  },
};

const OR4Hero = () => {
  const path = usePathname();

  return (
    <HomeHeroWithChicletWrapper data-cy="home-or4-hero-wrapper">
      <InverseHeader>
        <div data-cy="or4-hero">
          <HomeHero
            heroContent={{
              button: {
                children: null,
                className: 'bg-slate-900 hover:bg-sandstone-500 font-bold',
                label: 'gen4_hero_cta',
                href: '/store/rings',
                onClick: () => {
                  void window.ouraAnalytics.track(EventType.CTAClicked, {
                    cta: 'shop_now',
                    action: 'go_to_pdp',
                    location: 'home hero',
                    path,
                  });
                },
                variant: 'secondary-dark',
              },
              icon: <HsaFsaIcon />,
            }}
            overlayPosition="absolute"
            TopSlot={<OR4HeroBackground />}
            TitleSlot={
              <div className="mt-40 md:mt-[27.5vh] md:max-w-[540px] lg:max-w-[46%]">
                <span className="mb-2 flex flex-row items-center justify-center md:mb-5 md:justify-start">
                  <OuraRing4Logo />
                </span>
                <Typography
                  Element="h1"
                  variant="h1"
                  className="flex flex-col items-center bg-linear-to-br from-slate-900 to-mustard-500 bg-clip-text leading-none font-medium text-transparent sm:text-4xl md:items-start md:text-6xl lg:text-[6.667vw] xxl:text-8xl lg:de:text-[5vw] xxl:de:text-7xl"
                  color="light"
                >
                  <RichText
                    messageKey="sleeker_smarter_ring_title"
                    tValues={gen4RichText}
                  />
                </Typography>
              </div>
            }
          />
        </div>
      </InverseHeader>
      <StatsigHomeHeroShopChiclet />
    </HomeHeroWithChicletWrapper>
  );
};

export default OR4Hero;
